<aig-modal class="aig-modal-open-claim" position="center" customMaxWidth="600px">
  <div class="u-p-8 u-pb-3" body>
    <div class="p-flexcc u-dir-col">
      <img src="./assets/images/logos/logo.svg" class="u-mb-3" />
      <p class="u-fs-18 u-fw-400 u-color-black u-mt-def">
        Recuerda que tan solo puede haber un siniestro abierto.
        Se debe finalizar el siniestro abierto para gestionar uno nuevo.
        Para cualquier consulta puedes escribirnos a
        <a href="mailto:backoffice.caixa@icp.es" class="u-color-selected1">
          {{ supportEmail }}
        </a>
      </p>
    </div>
  </div>
  <div class="u-p-8 u-pt-def" buttons>
    <button class="e-btn--primary p-flexcc u-size-per-100" (click)="clickHide()">
      <p class="u-fs-16 u-fw-600">Aceptar</p>
    </button>
  </div>
</aig-modal>